interface WindowWithForethought extends Window {
  Forethought: (target: string, action: string) => void;
}
export function openForethoughtWidget() {
  if (window && 'Forethought' in window) {
    (window as unknown as WindowWithForethought).Forethought('widget', 'open');
    return true;
  }
  return false;
}
